"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var path_1 = require("../../utils/shopify/path");
var bundle_products_module_1 = require("../../utils/shopify-graphql/bundle-products-module");
var Parser_1 = require("../Parser");
var CtaButton_1 = require("../common/Btn/CtaButton");
var color_1 = require("../common/color");
var BundleProductsModule = function () {
    var _a = (0, hooks_1.useState)(null), data = _a[0], setData = _a[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, bundle_products_module_1.getBundleProductsData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)("div", { style: data.backgroundColor ? { background: (0, color_1.toHex)(data.backgroundColor) } : '', class: "bundle-products-module" },
        (0, preact_1.h)("h2", { style: data.color ? { color: (0, color_1.toHex)(data.color) } : '', class: "bundle-products-module__header" }, (0, Parser_1.parse)(data.header)),
        (0, preact_1.h)("p", { class: "bundle-products-module__subheader" }, (0, Parser_1.parse)(data.subheader)),
        (0, preact_1.h)("div", { class: "bundle-products-module__prod-list" }, data.prodList.map(function (item, index) {
            return ((0, preact_1.h)("div", { key: index, class: "bundle-products-module__prod-container" },
                (0, preact_1.h)("img", { class: "bundle-products-module__prod-image", src: item.prodImage, alt: "product image" }),
                (0, preact_1.h)("div", { class: "bundle-products-module__prod-content" },
                    (0, preact_1.h)("p", { class: "bundle-products-module__prod-title" }, (0, Parser_1.parse)(item.title)),
                    (0, preact_1.h)("p", { class: "bundle-products-module__prod-description" }, (0, Parser_1.parse)(item.description)))));
        })),
        (0, preact_1.h)("p", { class: "bundle-products-module__claim" }, data.claim),
        (0, preact_1.h)(CtaButton_1.default, { text: "SHOP NOW", textColor: data.ctaColor.text, backgroundColor: {
                to: 'Left',
                startColor: data.ctaColor.backgroundStart || 'white',
                endColor: data.ctaColor.backgroundEnd || 'white',
            }, hoverColor: data.ctaColor.hover || 'white' })));
};
exports.default = BundleProductsModule;
